import Axios from 'axios';
import appUrl from '../../app/features/constants/appUrl';
import { axiosApi } from '../../app/features/constants/axios_api';

const { createSlice, createAsyncThunk } = require('@reduxjs/toolkit');

const vehicleMakersSlice = createSlice({
    name: 'vehicleMakers',
    initialState: { },
    reducers: {
        resetAddEditVehicleMakers(state, action) {
            return { ...state, addSuccess: undefined, editSuccess: undefined, deleteMakeSuccess: undefined }
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getVehicleMakers.pending, (state, action) => {
                return {loading:true}
            })
            .addCase(getVehicleMakers.fulfilled, (state, action) => {
               
                return {loading:false,data:action.payload}
            })
            .addCase(getVehicleMakers.rejected, (state, action) => {
                return {
                    loading:false,
                    error:action.error.response && action.error.response.data.msg
                    ? action.error.response.data.msg
                    : action.error.message
                }
            });
            builder
            .addCase(addVehicleMaker.pending, (state, action) => {
                return { ...state, addLoading: true }
            })
            .addCase(addVehicleMaker.fulfilled, (state, action) => {
                // //console.log(action.payload);

                return { ...state, addLoading: false, addData: action.payload ,addSuccess:true}
            })
            .addCase(addVehicleMaker.rejected, (state, action) => {

                return {
                    ...state,
                    addLoading: false,
                    addError: action.payload,
                    addSuccess:false
                }
            });
            builder
            .addCase(updateVehicleMake.pending, (state, action) => {
                return { ...state, updateLoading: true }
            })
            .addCase(updateVehicleMake.fulfilled, (state, action) => {

                return { ...state, updateLoading: false, updateData: action.payload ,updateSuccess:true}
            })
            .addCase(updateVehicleMake.rejected, (state, action) => {

                return {
                    ...state,
                    updateLoading: false,
                    updateError: action.payload,
                    updateSuccess:false
                }
            });
            builder
            .addCase(deleteVehicleMake.pending, (state, action) => {
                return { ...state, deleteLoading: true }
            })
            .addCase(deleteVehicleMake.fulfilled, (state, action) => {

                return { ...state, deleteLoading: false, deleteData: action.payload,deleteMakeSuccess:true }
            })
            .addCase(deleteVehicleMake.rejected, (state, action) => {

                return {
                    ...state, deleteLoading: false,
                    error: action.payload,
                    deleteMakeSuccess:false
                }
            });
    },
});
export default vehicleMakersSlice.reducer;
export const { resetAddEditVehicleMakers } = vehicleMakersSlice.actions;

// Thunks
export const getVehicleMakers = createAsyncThunk('vehicleMakers/fetch', async (id, { rejectWithValue, fulfillWithValue }) => {
    try {
        const { data } = await axiosApi.get(appUrl.baseUrl + appUrl.getVehicleMaker);
        // //console.log("vehicle makers",data)
        return fulfillWithValue(data.data);
    } catch (error) {

        throw rejectWithValue(error.response && error.response.data.msg
            ? error.response.data.msg
            : error.message)
    }
});


export const addVehicleMaker = createAsyncThunk('addVehicleMaker/add', async (body, { rejectWithValue, fulfillWithValue }) => {
    try {
        const { data } = await axiosApi.post(appUrl.baseUrl + appUrl.addVehicleMaker, body);
        return fulfillWithValue(data.data);
    } catch (error) {

        throw rejectWithValue(error.response && error.response.data.msg
            ? error.response.data.msg
            : error.message)

    }
});

export const updateVehicleMake = createAsyncThunk('vehicleMake/update', async (body, { rejectWithValue, fulfillWithValue }) => {
    try {
        const { data } = await axiosApi.patch(appUrl.baseUrl + appUrl.updateVehicleMake, body);
        return fulfillWithValue(data.data);
    } catch (error) {

        throw rejectWithValue(error.response && error.response.data.msg
            ? error.response.data.msg
            : error.message)

    }

});

export const deleteVehicleMake = createAsyncThunk('ads/delete', async (body, { rejectWithValue, fulfillWithValue }) => {
    try {
   
        const { data } = await axiosApi.delete(appUrl.baseUrl + appUrl.deleteVehicleMake+`?makeId=${body.makeId}`);
        return fulfillWithValue(data.data);
    } catch (error) {

        throw rejectWithValue(error.response && error.response.data.msg
            ? error.response.data.msg
            : error.message)

    }
});